import React from "react";
import { createSvgIconComponent } from "../utils";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var IconCreditCard = createSvgIconComponent({
  children: [___EmotionJSX("rect", {
    key: "part-1",
    width: "50",
    height: "31.6667",
    rx: "5",
    fill: "#D9D9D9"
  }), ___EmotionJSX("rect", {
    key: "part-2",
    y: "6.66699",
    width: "50",
    height: "8.33333",
    fill: "#B3B3B8"
  }), ___EmotionJSX("rect", {
    key: "part-3",
    x: "5",
    y: "18.3335",
    width: "40",
    height: "6.66667",
    fill: "white"
  })],
  fill: "none",
  viewBox: "0 0 50 32"
});